import { Stack, useStrategiesContext } from '@talos/kyoko';
import { OrderRequestChangedBanner } from '../../components/OrderRequestChangedBanner';
import { useOrderRequestChanged } from '../../hooks/useOrderRequestChanged/useOrderRequestChanged';
import type { PreTradeResponseData } from '../../redux/preTradeApi';
import { OrderTrajectory } from './OrderTrajectory/OrderTrajectory';
import { PublicMarkets } from './PublicMarkets/PublicMarkets';
import { SnipeSweepBounds } from './SnipeSweepBounds/SnipeSweepBounds';
import { isSniperScenario } from './SnipeSweepBounds/utils';
import { StrategySummary } from './StrategySummary/StrategySummary';
import { TotalCostRisk } from './TotalCostRisk/TotalCostRisk';
import { PreTradePredictions } from './TradePredictions/PreTradePredictions';

interface DetailsTabProps {
  scenario: PreTradeResponseData;
  showNonConsidered: boolean;
  isActiveSession: boolean;
}

export function DetailsTab({ scenario, showNonConsidered, isActiveSession }: DetailsTabProps) {
  const hasOrderRequestChanged = useOrderRequestChanged(scenario);
  const { strategiesByName } = useStrategiesContext();

  // Strategy summary first; sniper shows bounds chart before cost/risk (see design mock).
  const isSniper = isSniperScenario(scenario, strategiesByName);

  return (
    <Stack alignItems="stretch" gap="spacing8">
      {hasOrderRequestChanged && <OrderRequestChangedBanner isActiveSession={isActiveSession} />}
      <Stack gap="spacing16" alignItems="stretch" p="spacing16">
        <StrategySummary scenario={scenario} showNonConsidered={showNonConsidered} />
        {isSniper && <SnipeSweepBounds scenario={scenario} />}
        <TotalCostRisk scenario={scenario} />
        <PreTradePredictions scenario={scenario} />
        {!isSniper && <OrderTrajectory scenario={scenario} />}
        <PublicMarkets scenario={scenario} />
      </Stack>
    </Stack>
  );
}
